import {BifrostBackendNestApi} from "../gateways/BifrostBackendApi";
import {store} from "../store";

export default {
	async listByClientTraceId() {
		const response = await BifrostBackendNestApi.get("/limited-discount-assignment", {
			headers: {
				Authorizationidp: store.getters.applicationUserIdpToken
			}
		});

		return response.data;
	}
};
